import {
	createActionsHook,
	type BoundActions,
	type HookActionsFunction,
	type StoreActionApi,
} from 'react-sweet-state';

import { type DocNode } from '@atlaskit/adf-schema';

import type { State } from './State';
import { store } from './store';

export const useDataSculptorModalActions: HookActionsFunction<
	BoundActions<
		State,
		{
			openModal: (data: string | DocNode) => ({ setState }: StoreActionApi<State>) => void;
			closeModal: () => ({ setState }: StoreActionApi<State>) => void;
		}
	>
> = createActionsHook(store);
